export default {"src":"/_next/static/media/0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};